import React, { Component } from 'react'
import { Input, Button } from '@driftt/tide'
import CategorySelector from 'components/Editor/CategorySelector'
import URLInput from 'components/URLInput'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from 'modules/knowledgebase/actions'
import { getArticle, getCategories, getArticleErrors } from 'modules/knowledgebase/selectors'
import { getCanonicalDomain } from 'modules/settings/selectors'
import { sanitizeSlug } from 'modules/knowledgebase/helpers'

import cx from 'classnames'

import './style.css'

class ArticleModalContent extends Component {
  
  constructor(props) {
    super(props)
    
    this.state = {
      title: props.article.title,
      slug: props.article.slug
    }
  }
  
  slugManuallyChanged = false
  
  componentDidMount() {
    const { actions, categoryId, sectionId, isEditing } = this.props
    
    if (!isEditing) {
      sectionId ? actions.setArticleSection({ sectionId, categoryId }) : actions.setArticleCategory(categoryId)
    }
  }
  
  componentWillUnmount() {
    const { actions, errors } = this.props
    const titleErrors = errors.filter(e => e.title)
    const slugErrors = errors.filter(e => e.slug)
    
    if (!titleErrors.length && !slugErrors.length) {
      actions.clearArticleErrors()
    }
  }
  
  handleTitleChange = e => {
    const { actions, orgId, isEditing } = this.props
    const title = e.target.value
    const slug = sanitizeSlug(title)
    
    this.setState({title}, () => actions.checkTitle({orgId, title}))
    
    if (!this.slugManuallyChanged && !isEditing) {
      this.setState({slug})
    }
  }
  
  handleURLChange = e => {
    const { actions, orgId } = this.props
    const slug = sanitizeSlug(e.target.value)
    
    this.slugManuallyChanged = true
    
    this.setState({ slug }, () => actions.checkSlug({ orgId, slug }))
  }
  
  handleActionButtonClick = () => {
    const { isEditing, onCloseModal, actions } = this.props
    const { title, slug } = this.state
    
    actions.setTitle(title)
    actions.setSlug(slug)
    
    isEditing ? actions.editArticle() : actions.createArticle()
    onCloseModal()
  }
  
  render() {
  
    if (!this.props.categories.length) return null
  
    const { categories, article, hostName, errors, onCloseModal, isEditing } = this.props
    const { title, slug } = this.state
    const articleCatId = article.categoryId || categories[0].id
    const selectedCategory = categories.find(c => c.id === articleCatId)
    
    const titleErrors = errors.filter(e => e.title)
    const slugErrors = errors.filter(e => e.slug)
    
    const label = isEditing ? 'Article Settings' : 'Create a New Article'
    const actionButtonText = isEditing ? 'Save Settings' : 'Create Article'
  
    const errorExists = titleErrors.length > 0 || slugErrors.length > 0
    
    return (
      <div className="article-modal-content-wrapper">
        <p className="article-modal-content-label">{label}</p>
        <div className="article-modal-content-form">
          <Input
            type="text"
            label="Article Title"
            className={cx('article-modal-content-title-input', { error: titleErrors.length > 0 })}
            placeholder="Name this article..."
            onChange={this.handleTitleChange}
            value={title}
          />
  
          {titleErrors && titleErrors.map(te => <span key={te.message} className="input-error-message">{te.message}</span>)}
  
          <span className="article-modal-content-url-input-label">
            Link to Article
          </span>
          <URLInput
            url={`${hostName}/article/`}
            value={slug}
            onChange={this.handleURLChange}
            className='long-url'
            errors={slugErrors}
          />
  
          {slugErrors && slugErrors.map(se => <span key={se.message} className="input-error-message">{se.message}</span> )}
          
          <span className="article-modal-content-category-selector-label">
            Located In:
          </span>
          <CategorySelector
            selectedCategory={selectedCategory}
            article={article}
            articleCatId={articleCatId}
          />
          
          <div className="article-modal-content-button-section">
            <Button
              className="article-modal-content-buttons article-modal-content-delete-button"
              size="medium"
              onClick={this.handleActionButtonClick}
              disabled={title.length === 0 || errorExists}
            >
              {actionButtonText}
            </Button>
            <Button
              type="tertiary"
              size="medium"
              className="article-modal-content-buttons article-modal-content-cancel-button"
              onClick={onCloseModal}
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  article: getArticle(state),
  categories: getCategories(state),
  hostName: getCanonicalDomain(state),
  orgId: state.user.orgId,
  errors: getArticleErrors(state),
  sectionId: !props.isEditing ? parseInt(props.match.params.sectionId, 10) : null,
  categoryId: !props.isEditing ? parseInt(props.match.params.categoryId, 10) : null
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    setTitle: actions.setTitle,
    setSlug: actions.setSlug,
    setArticleCategory: actions.setArticleCategory,
    setArticleSection: actions.setArticleSection,
    checkTitle: actions.checkTitle,
    checkSlug: actions.checkSlug,
    createArticle: actions.createArticle,
    editArticle: actions.editArticle,
    clearArticleErrors: actions.clearArticleErrors
  }, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(ArticleModalContent)